import { CALL_API } from './api'
import { getToken } from 'Lib'
// import types from '../types'
export default store => next => action => {

	const entry = action[CALL_API]
	// const ignorTypes  = [types.]
	if (typeof entry !== 'object') return next(action)

	let token
	const entryType = entry.types[0]
	if (typeof entryType === 'string' && entryType.startsWith("CORE")) {
		token = getToken()
	}

	if (!token) return next(action)

	entry.headers = { ...entry.headers }
	if (token) {
		entry.headers.Authorization = `Bearer ${token}`
		// entry.headers["Access-Control-Allow-Origin"] = "*"
		// entry.headers["Access-Control-Allow-Methods"] = "DELETE, POST, GET, OPTIONS"
		// entry.headers["Access-Control-Allow-Headers"] = "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With"
	}
	next(action)
}


// WEBPACK FOOTER //
// ./src/display/middlewares/setToken.js